import httpInstance, { token } from "./config";

const makeHttpRequest = ({
    url = "/",
    method = "get",
    params = {},
    data = {},
    headers = {},
    responseType = "json",
    signal,
    silentRefusal = false,
}) => {
    if (token) headers.authorization = `Bearer ${token}`;

    // silentRefusal — для фоновых запросов, которые кабинет делает сам:
    // отказ по правам на них не надо показывать человеку всплывашкой,
    // вызывающий код разбирается с ним молча
    return httpInstance.request({
        url,
        method,
        headers,
        params,
        data,
        responseType,
        signal,
        silentRefusal,
    });
};

export default makeHttpRequest;
